import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editActivityConfirmSuccess",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  "aria-labelledby": "editActivityConfirmSuccess",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editActivityConfirm"
}
const _hoisted_6 = { class: "modal-body p-0" }
const _hoisted_7 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_8 = { class: "d-flex justify-content-center mb-4" }

import { PropType } from 'vue'

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  reset: {
    type: Function as PropType<() => void | undefined>,
  },
  serverErrorActivities: String,
  id: String,
},
  setup(__props) {

const props = __props



const messageComplete = () => {
  if (props.serverErrorActivities === 'create') {
    return 'SG43createError'
  }
  if (props.serverErrorActivities === 'update') {
    return 'SG43updateError'
  }
  return props.id ? 'updateActivityComplete' : 'registered'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.id ? _unref(translate)('SG43editActivity') : _unref(translate)('SG43addActivity')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.reset && __props.reset(...args))),
            "aria-label": "Close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)(messageComplete())), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              onClick: __props.reset,
              "data-bs-dismiss": "modal",
              type: 'secondary',
              title: _unref(translate)('close')
            }, null, 8, ["onClick", "title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})